/**
 * Waits x seconds until it completes the promise.
 * @param {number} seconds The amount of seconds to wait for.
 */
export async function waitForSeconds(seconds) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(), seconds * 1000);
    });
}

export function createCancellable(func) {
    let cancelled = false;
    const result = () => new Promise(async (resolve) => {
            const ret = await func();
            if (!cancelled) resolve(ret);
        });

    result.cancel = () => { cancelled = true; };

    return result;
}
